"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Headline = _interopRequireDefault(require("../Headline"));

var _PasswordField = _interopRequireDefault(require("../PasswordField"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var FormChangePassword = function FormChangePassword(_ref) {
  var t = _ref.t,
      _ref$showPasswordDefa = _ref.showPasswordDefault,
      showPasswordDefault = _ref$showPasswordDefa === void 0 ? false : _ref$showPasswordDefa,
      _ref$errorStyle = _ref.errorStyle,
      errorStyle = _ref$errorStyle === void 0 ? _styleModule.default.error : _ref$errorStyle,
      _ref$translateNs = _ref.translateNs,
      translateNs = _ref$translateNs === void 0 ? 'ui' : _ref$translateNs;

  var _useFormContext = (0, _reactHookForm.useFormContext)(),
      register = _useFormContext.register,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var componentNs = "".concat(translateNs, ":ui.Form.ChangePassword");

  var nonEmpty = function nonEmpty(value) {
    if (errors.passwordEmpty && value !== '') {
      clearErrors('passwordEmpty');
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
      center: false,
      text: t("".concat(componentNs, ".headline")),
      topMargin: true
    }, "headlinePasswordSection"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordField.default, {
      register: register('password', {
        validate: nonEmpty
      }),
      placeholder: t("".concat(componentNs, ".placeholders.password")),
      name: "password",
      showPasswordDefault: showPasswordDefault
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordField.default, {
      register: register('passwordNew', {
        validate: nonEmpty
      }),
      placeholder: t("".concat(componentNs, ".placeholders.passwordNew")),
      name: "passwordNew"
    }), errors.passwordEmpty && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: errorStyle,
      children: errors.passwordEmpty.message
    })]
  });
};

var _default = FormChangePassword;
exports.default = _default;